const isDevelopment = false;

export const SERVER_ROOT = isDevelopment ? "http://localhost:3001/" : "https://codeposter.net/";